import pipe from 'ramda/src/pipe'
import map from 'ramda/src/map'
import path from 'ramda/src/path'
import prop from 'ramda/src/prop'
import split from 'ramda/src/split'
import when from 'ramda/src/when'
import pathEq from 'ramda/src/pathEq'
import is from 'ramda/src/is'
import uniq from 'ramda/src/uniq'
import filter from 'ramda/src/filter'
import equals from 'ramda/src/equals'
import dropEventHof from 'root/src/client/logic/dropEvent/util/dropEventHof'
import { brandProductTypesEnum } from 'root/src/shared/constants/dropEvent'

export default state => pipe(
	dropEventHof('dares'),
	when(
		is(Array),
		pipe(
			filter(pathEq(['product', 'type'], brandProductTypesEnum.dropKey)),
			filter(dare => equals(
				Number(
					pipe(
						path(['product', 'id']),
						split('|'),
						prop(0),
						split('-'),
						prop(1),
					)(dare),
				),
				path(['games', 0, 'id'], dare),
			)),
			map(pipe(path(['product', 'id']), split('|'), prop(1))),
			uniq,
		),
	),
)(state)
